import { z } from "zod"

import {
  fieldProjectionV7Schema,
  fieldVisitProjectionV7Schema,
} from "./field-projection-v7.js"

export const fieldVisitProjectionV8Schema = fieldVisitProjectionV7Schema

export const fieldProjectionV8Schema = z
  .object({
    ...fieldProjectionV7Schema.shape,
    responseVersion: z.literal(8),
    workerDisplayName: z.string().trim().min(1).max(160),
  })
  .strict()
  .superRefine((projection, context) => {
    const { workerDisplayName: _workerDisplayName, ...candidate } = projection
    const legacy = fieldProjectionV7Schema.safeParse({
      ...candidate,
      responseVersion: 7,
    })
    if (!legacy.success) {
      for (const issue of legacy.error.issues) {
        context.addIssue({
          code: "custom",
          message: issue.message,
          path: issue.path,
        })
      }
    }
  })

export type FieldProjectionV8 = z.infer<typeof fieldProjectionV8Schema>
export type FieldVisitProjectionV8 = z.infer<
  typeof fieldVisitProjectionV8Schema
>
